var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08525 0.635359C6.80263 0.938172 6.81899 1.41276 7.12181 1.69539C8.18638 2.69207 9.2514 3.73701 10.1407 4.8971L0.883616 4.8971C0.469403 4.8971 0.133545 5.23288 0.133545 5.6471C0.133545 6.06131 0.469969 6.3971 0.884182 6.3971L10.1407 6.3971C9.251 7.55771 8.18863 8.59998 7.12181 9.59881C6.81899 9.88143 6.80263 10.356 7.08525 10.6588C7.36788 10.9616 7.84259 10.9779 8.1454 10.6953C9.30479 9.61268 10.4436 8.49415 11.3976 7.2221C11.7321 6.77605 12.1335 6.23052 12.1335 5.6471C12.1335 5.06368 11.7321 4.51814 11.3976 4.0721C10.4493 2.80769 9.29442 1.67791 8.14528 0.598806C7.84247 0.316181 7.36788 0.332546 7.08525 0.635359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardWhite);
export default __webpack_public_path__ + "static/media/forwardWhite.f2e3ed9110daf99374741d6b40dbb236.svg";
export { ForwardRef as ReactComponent };